/**
 * SAAS-CLAIM-UI — helpers puros dos códigos de vínculo (claim codes).
 *
 * Só UX/apresentação (o backend é a fonte da verdade e já valida/403). Mantido
 * puro e testável (frontend/test/claim_codes.test.mjs).
 */

/** Papéis que podem GERAR/LISTAR/REVOGAR claim codes (super_admin/field). */
export const CLAIM_MANAGER_ROLES = ["super_admin", "field"];

/** true se o papel pode gerir claim codes (super_admin sempre pode). */
export function canManageClaimCodes(role) {
  return CLAIM_MANAGER_ROLES.includes(role || "");
}

/** allow_rebind (revincular device de outro tenant) só platform admin. */
export function canAllowRebind(isPlatformAdmin) {
  return isPlatformAdmin === true;
}

/** Rótulo + tom PT-BR para o estado do código (espelha code_state do backend). */
export function claimStateBadge(state) {
  switch (state) {
    case "active":
      return { label: "Ativo", tone: "ok" };
    case "used":
      return { label: "Usado", tone: "muted" };
    case "expired":
      return { label: "Expirado", tone: "warn" };
    case "revoked":
      return { label: "Revogado", tone: "err" };
    default:
      return { label: state || "—", tone: "muted" };
  }
}

/** Só códigos ATIVOS podem ser revogados. */
export function canRevoke(state) {
  return state === "active";
}

/** Opções de validade (horas) para o seletor de TTL. */
export const TTL_OPTIONS = [
  { hours: 24, label: "24 horas" },
  { hours: 72, label: "3 dias" },
  { hours: 168, label: "7 dias" },
  { hours: 336, label: "14 dias" },
  { hours: 720, label: "30 dias" },
];

/** Data ISO → texto curto pt-BR; vazio se ausente. Puro (sem locale de runtime). */
export function fmtWhen(iso) {
  if (!iso) return "—";
  // mantém determinístico: usa as partes do ISO (YYYY-MM-DDTHH:MM)
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(String(iso));
  if (!m) return String(iso);
  const [, y, mo, d, h, mi] = m;
  return `${d}/${mo}/${y} ${h}:${mi}`;
}
